(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.correspondence-modal
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.data.userMessages :as d-userMessages]
            [teamoesterreich.util.log :as log]))


(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) " " (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))

(def TYPE_MAP {"sms"   "SMS"
               "email" "Email"
               "push"  "Push"
               })


(defn content [msg]
  ;(log/debug (clj->js msg))
  [:div {:style {:border           "1px dotted grey"
                 :background-color "#c4c4f1"
                 :margin-right     "10px"
                 }}
   (:userMessage-message msg) "" (:userMessage-longContent msg)]
  )



(defn modal [!st !show]
  (let [list (reverse (sort-by (fn [[k e]] (:userMessage-date e)) (:list @!st)))
        cnt (count list)]
    [mui/modal
     {:className        "correspondence-modal"
      :aria-labelledby  "simple-modal-title"
      :aria-describedby "simple-modal-description"
      :style            {:display        "flex"
                         :marginRight    "auto"
                         :marginLeft     "auto"
                         :alignItems     "center"
                         :justifyContent "center"}
      :open             (or @!show false)

      }


     [:div
      {
       :class "modal"
       :style {:width 750}}
      [mui/grid {:container  true
                 :direction  "row"
                 :justify    "space-between"
                 :alignItems "flex-start"}
       [mui/grid {:container false :item true :xs 12}

        [:h2 "Korrespondenz Liste für " @!show " " cnt " Nachrichten"]


        [:ul {:style {:overflow-y "scroll" :max-height "500px"}}
         (if (> cnt 0)
           (for [[uuid msg] list]
             ^{:key (str "message-" uuid)}
             [:li {:style {:marginBottom "10px"}}
              (get TYPE_MAP (:userMessage-type msg))
              " `" (:userMessage-title msg) "`"
              [:span {:style {:float "right" :margin-right "10px"}}
               [:span {:style {:color "blue"}} (:userMessage-sender msg)]
               "    "
               (datetime-conv (:userMessage-date msg))
               ]
              [:br]
              [content msg]])

           ;none
           (do [:li {} [:span "Keine Nachrichten gesendet"]])
           )

         ]
        [:br]
        [:br]
        ]

       [mui/grid {:container false :item true
                  :xs        6
                  :style     {}}
        [mui/grid {:container false :item true :xs 6}
         [mui/button
          {:variant   "contained"
           :startIcon (r/as-element [keyboard-arrow-left])
           :style     {:marginRight 50}
           :onClick   #(reset! !show false)
           }
          "Abbrechen"]]
        ]]]]
    ))





(defn get-user-correspondence [!st tomId]
  (d-userMessages/get-user-messages tomId (fn [data]
                                            (reset! !st {:list     data
                                                         :reqTomId tomId}))))


(defn modal-by-tomId [!tomId]
  (let [!st (r/atom {:reqTomId nil :list []})]
    (fn []
      (let [tomId @!tomId]

        (when (and (pos? tomId) (not= tomId (:reqTomId @!st)))
          (get-user-correspondence !st tomId))

        (if (or (not= @!tomId (:reqTomId @!st))
                (:error @!st))
          ;no data
          [mui/modal
           {:className        "correspondence-load-modal"
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !st {:reqTomId nil :list []})
                                (reset! !tomId nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}

            [:h4 (str "Freigabe verlängern: " tomId)]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error @!st)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !st {:reqTomId nil :list []})
                          (reset! !tomId {}))
              }
             "Schließen"]
            ]]
          ;has data
          [modal !st !tomId]

          )
        ))))